import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import ro from './locales/ro.json';
import en from './locales/en.json';

function readStoredAppearance(): { theme?: string; language?: string } {
  try {
    return JSON.parse(localStorage.getItem('fh-appearance') || '{}');
  } catch {
    return {};
  }
}

function getInitialLanguage(): string {
  return readStoredAppearance().language || 'ro';
}

function applyStoredTheme(): void {
  const theme = readStoredAppearance().theme;
  const root = document.documentElement;
  if (theme === 'dark') {
    root.classList.add('dark');
  } else if (theme === 'light') {
    root.classList.remove('dark');
  } else if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }
}

const initialLang = getInitialLanguage();

i18n.use(initReactI18next).init({
  resources: {
    ro: { translation: ro },
    en: { translation: en },
  },
  lng: initialLang,
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false, // React already escapes
  },
});

// Keep <html lang="…"> and theme class in sync with stored appearance
document.documentElement.lang = initialLang;
applyStoredTheme();
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
